import isAdmin from './isAdmin';

const isHRUser = (user: any) => {
  if (user?.roles?.includes('user') && user?.group?.name === 'HRUser') {
    return true;
  }

  return false;
};

export const canManageUserEmail = (user: any) => isAdmin(user) || isHRUser(user);

export default isHRUser;
